import { render, staticRenderFns } from "./drilldown-report-page-tab.vue?vue&type=template&id=b4cd56dc&"
import script from "./drilldown-report-page-tab.vue?vue&type=script&lang=js&"
export * from "./drilldown-report-page-tab.vue?vue&type=script&lang=js&"
import style0 from "./drilldown-report-page-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports